import { ArrowDownToLine, Boxes, Activity, BarChart3, Bot, ChevronRight, CircleDollarSign, ClipboardCheck, KeyRound, LayoutDashboard, Link2, LogOut, Menu, ShieldCheck, X } from "lucide-react";
import { useState } from "react";
import { ShieldEllipsis, UserRound, Wrench } from "lucide-react";
import { Avatar } from "./Avatar";
import { VerifyBanner } from "../pages/Security";

export const MEMBER_NAV = [
  { id: "overview", label: "Overview", icon: LayoutDashboard },
  { id: "accounts", label: "Akun trading", icon: Activity },
  { id: "performance", label: "Kurva performa", icon: BarChart3 },
  { id: "sharing", label: "Profit sharing", icon: CircleDollarSign, badge: "20%" },
  { id: "affiliate", label: "Affiliate", icon: Link2 },
  { id: "ea", label: "Sewa EA", icon: Bot },
  { id: "profile", label: "Profil", icon: UserRound },
  { id: "security", label: "Keamanan akun", icon: ShieldEllipsis },
];
export const ADMIN_NAV = [
  { id: "admin-overview", label: "Admin console", icon: ShieldCheck },
  { id: "admin-payments", label: "Verifikasi QRIS", icon: ClipboardCheck },
  { id: "admin-rentals", label: "Sewa EA aktif", icon: Wrench },
  { id: "admin-withdrawals", label: "Penarikan komisi", icon: ArrowDownToLine },
  { id: "admin-ea", label: "Katalog EA", icon: Boxes },
  { id: "admin-settings", label: "Integrasi", icon: KeyRound },
];

const NavList = ({ items, page, go }) => items.map((n) => {
  const I = n.icon;
  return (
    <button key={n.id} className={page === n.id ? "nav-item active" : "nav-item"} onClick={() => go(n.id)} data-testid={`nav-${n.id}`}>
      <I size={17} /><span>{n.label}</span>{n.badge && <i>{n.badge}</i>}
    </button>
  );
});

export default function Shell({ user, page, setPage, onLogout, flash, children }) {
  const [mobile, setMobile] = useState(false);
  const isAdmin = user.role === "admin";
  const go = (id) => { setPage(id); setMobile(false); };
  const title = [...MEMBER_NAV, ...ADMIN_NAV].find((n) => n.id === page)?.label;
  return (
    <div className="shell">
      <aside className={mobile ? "sidebar open" : "sidebar"}>
        <div className="brand"><span className="brand-mark">P</span><span>POJOK CHART</span>
          <button className="icon-btn mobile-close" onClick={() => setMobile(false)} data-testid="close-menu-button"><X size={18} /></button>
        </div>
        <div className="workspace"><Avatar avatarId={user.avatar_id} name={user.alias || user.name} testId="sidebar-avatar" /><span><b>{user.alias || user.name}</b><small>{isAdmin ? "Administrator" : "Member account"}</small></span><ChevronRight size={15} /></div>
        <nav>
          <NavList items={MEMBER_NAV} page={page} go={go} />
          {isAdmin && <><p className="nav-label">ADMIN</p><NavList items={ADMIN_NAV} page={page} go={go} /></>}
        </nav>
        <div className="sidebar-bottom">
          <button className="nav-item" onClick={onLogout} data-testid="logout-button"><LogOut size={17} /><span>Keluar</span></button>
        </div>
      </aside>
      <main className="main">
        <header className="topbar">
          <button className="icon-btn menu-button" onClick={() => setMobile(true)} data-testid="open-menu-button"><Menu size={20} /></button>
          <div><span className="section-kicker">{page.startsWith("admin") ? "ADMIN CONSOLE" : "MEMBER TERMINAL"}</span><h1 data-testid="page-title">{title}</h1></div>
          <div className="top-actions"><span className="live-dot"><b /> Auto-sync 5 menit</span><Avatar avatarId={user.avatar_id} name={user.alias || user.name} className="mini-avatar" testId="topbar-avatar" /></div>
        </header>
        <div className="content">{!user.alias && page !== "profile" && <div className="verify-banner" data-testid="complete-profile-banner"><span>Lengkapi <b>nama samaran</b> Anda di profil.</span><button className="outline sm" onClick={() => go("profile")} data-testid="complete-profile-button">Buka profil</button></div>}<VerifyBanner user={user} />{flash && <div className="notice info" data-testid="flash-message">{flash}</div>}{children}</div>
      </main>
    </div>
  );
}
